import { Directive, ElementRef, EventEmitter, HostListener, Output, Input } from '@angular/core';
@Directive({
  selector: '[amountMask]'
})
export class AmountMaskDirective {
  
  @Input() amountMask: boolean = true;
  @Output() numberChange = new EventEmitter<number>();

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    if (this.amountMask === false) return;

    const initialValue = this.el.nativeElement.value;
    let cleanedValue = initialValue;

    cleanedValue = cleanedValue.replace(/[^0-9,]/g, '');

    const commaCount = (cleanedValue.match(/,/g) || []).length;
    if (commaCount > 1) {
      let firstCommaFound = false;
      cleanedValue = cleanedValue.replace(/,/g, () => {
        if (!firstCommaFound) {
          firstCommaFound = true;
          return ',';
        }
        return '';
      });
    }

    const commaIndex = cleanedValue.indexOf(',');
    if (commaIndex !== -1) {
      const beforeComma = cleanedValue.substring(0, commaIndex);
      const afterComma = cleanedValue.substring(commaIndex + 1);

      const limitedAfterComma = afterComma.substring(0, 2);
      cleanedValue = beforeComma + ',' + limitedAfterComma;
    }

    this.el.nativeElement.value = cleanedValue;

    const regex = /^[0-9]*,?[0-9]{0,2}$/;
    if (regex.test(cleanedValue) || cleanedValue === '') {
      this.numberChange.emit(event);
    }
  }
}